"use client";

import React from "react";
import { Loader, CircleCheck } from "lucide-react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
export default function ContactForm() {
  return <section id="contactform" className="bg-background py-16 md:py-24">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-3xl md:text-4xl font-bold font-default text-foreground mb-4">
            Kontakta oss
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Har du frågor om din kommande badrumsrenovering? Fyll i formuläret nedan så återkommer vi till dig så snart som möjligt.
          </p>
        </div>

        <FormProvider formId="contact-form-main" sectionName="ContactForm" defaultValues={{
        name: "",
        email: "",
        message: ""
      }} validationRules={{
        name: {
          required: true,
          minLength: 2
        },
        email: {
          required: true,
          pattern: "email"
        },
        message: {
          required: true,
          minLength: 10
        }
      }} submitText="Skicka meddelande" successMessage="Tack för ditt meddelande! Vi återkommer till dig inom kort.">
          <ContactFormInner />
        </FormProvider>
      </div>
    </section>;
}
function ContactFormInner() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="bg-card border border-border rounded-xl shadow-sm p-8 md:p-12 text-center animate-in fade-in zoom-in duration-500">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-lg bg-green-50 text-green-600 mb-6">
          <CircleCheck className="w-8 h-8" />
        </div>
        <h3 className="text-2xl font-semibold font-default text-foreground mb-3">
          Meddelande skickat
        </h3>
        <p className="text-muted-foreground mb-8 max-w-md mx-auto">
          {successMessage}
        </p>
        <Button onClick={resetForm} variant="outline" className="min-w-[200px]">
          Skicka ett nytt meddelande
        </Button>
      </div>;
  }
  return <div className="bg-card border border-border rounded-xl shadow-sm p-6 md:p-8 lg:p-10">
      <Form onSubmit={handleSubmit}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
          <FormField control={control} name="name" rules={{
          required: "Fullständigt namn är obligatoriskt",
          minLength: {
            value: 2,
            message: "Minst 2 tecken krävs"
          }
        }} render={({
          field
        }) => <FormItem>
                <FormLabel>Fullständigt namn</FormLabel>
                <FormControl>
                  <Input placeholder="För- och efternamn" {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>} />

          <FormField control={control} name="email" rules={{
          required: "E-postadress är obligatorisk",
          pattern: {
            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
            message: "Ogiltig e-postadress"
          }
        }} render={({
          field
        }) => <FormItem>
                <FormLabel>E-postadress</FormLabel>
                <FormControl>
                  <Input type="email" placeholder="din.epost@exempel.se" {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>} />
        </div>

        <FormField control={control} name="message" rules={{
        required: "Meddelande är obligatoriskt",
        minLength: {
          value: 10,
          message: "Minst 10 tecken krävs"
        }
      }} render={({
        field
      }) => <FormItem className="mb-8">
              <FormLabel>Meddelande</FormLabel>
              <FormControl>
                <textarea className="flex min-h-[140px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-base md:text-sm shadow-xs placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 resize-y" placeholder="Beskriv ditt ärende eller din badrumsdröm..." {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        {submitError && <div className="p-4 mb-6 bg-destructive/10 border border-destructive/20 rounded-lg">
            <p className="text-destructive text-sm font-medium">{submitError}</p>
          </div>}

        <div className="flex justify-end">
          <Button type="submit" disabled={isSubmitting} className="w-full md:w-auto min-w-[200px]" size="lg">
            {isSubmitting ? <>
                <Loader className="animate-spin mr-2 size-5" />
                Skickar...
              </> : "Skicka meddelande"}
          </Button>
        </div>
      </Form>
    </div>;
}